import type { LucideProps } from 'lucide-react'
import React from 'react'

interface VerificationBadgeProps extends LucideProps {
  isVerified?: boolean
}

export const VerificationBadge = React.forwardRef<SVGSVGElement, VerificationBadgeProps>(
  ({ isVerified = false, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className={className}
        fill={isVerified ? 'hsl(var(--secondary))' : 'hsl(var(--muted) / 0.2)'}
        {...props}
      >
        <path d="M19.5139 8.82136L18.1499 7.45757C17.8261 7.13384 17.5608 6.49409 17.5608 6.03529V4.10656C17.5608 3.18906 16.8113 2.43954 15.8941 2.43906H13.9646C13.5063 2.43906 12.8658 2.17328 12.542 1.84979L11.1782 0.486004C10.5302 -0.162001 9.46924 -0.162001 8.82124 0.486004L7.45745 1.85077C7.13342 2.1745 6.49221 2.43954 6.03492 2.43954H4.10619C3.18992 2.43954 2.43942 3.18906 2.43942 4.10656V6.03534C2.43942 6.49233 2.17418 7.13408 1.8504 7.45762L0.486371 8.82141C-0.162124 9.46941 -0.162124 10.5304 0.486371 11.1794L1.8504 12.5432C2.17438 12.867 2.43942 13.5085 2.43942 13.9655V15.8943C2.43942 16.8108 3.18992 17.5613 4.10619 17.5613H6.03497C6.49323 17.5613 7.13372 17.8265 7.4575 18.1501L8.82129 19.5144C9.46929 20.1619 10.5303 20.1619 11.1783 19.5144L12.5421 18.1501C12.8661 17.8264 13.5064 17.5613 13.9646 17.5613H15.8941C16.8114 17.5613 17.5609 16.8108 17.5609 15.8943V13.9655C17.5609 13.5065 17.8264 12.8668 18.1499 12.5432L19.5139 11.1794C20.1614 10.5304 20.1614 9.46937 19.5139 8.82136ZM8.67675 13.7502L4.99946 10.0724L6.17799 8.89411L8.67705 11.3932L13.8213 6.25009L14.9996 7.42837L8.67675 13.7502Z" />
      </svg>
    )
  },
)
VerificationBadge.displayName = 'VerificationBadge'
